"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.base64ImageKeys = void 0;
exports.getBase64Image = getBase64Image;
const tslib_1 = require("tslib");
const nnq_1 = tslib_1.__importDefault(require("@futuweb/tool-nn/dist/nnq"));
const utils_1 = require("@futuweb/tool-nn/dist/utils");
const log_1 = tslib_1.__importDefault(require("./log"));
const base64ImageKeys = {
    // ID和base64的Map
    imageBase64Map: 'inviteGuide_imageBase64Map',
    // base64拉取方法
    fetchImageBase64ByID: 'inviteGuide_fetchImageBase64ByID',
    // 全局key
    globalKey: 'inviteGuide_base64Image',
};
exports.base64ImageKeys = base64ImageKeys;
const genId = (0, utils_1.genIdWrapper)('inviteGuide');
class Base64Image {
    constructor() {
        this.map = {};
    }
    getBase64Id() {
        const id = genId();
        return id;
    }
    set(base64, id) {
        this.map[base64] = id;
    }
    registerHandler() {
        if (window === null || window === void 0 ? void 0 : window.FEGOEditor)
            return;
        nnq_1.default.bridge.registerHandler(base64ImageKeys.fetchImageBase64ByID, (base64Id, callback) => {
            const [base64] = Object.entries(this.map).find(([base64, _base64Id]) => base64Id === _base64Id) || [];
            log_1.default.info('fetchImageBase64ByID', {
                base64Id,
                base64
            });
            if (base64) {
                callback(base64);
            }
            else {
                log_1.default.info('fetchImageBase64ByID fail', {
                    base64Id,
                    base64
                });
            }
        });
    }
    classifyImages(images) {
        const urls = [];
        const base64Ids = [];
        images.forEach((image) => {
            if (/^http/.test(image)) {
                urls.push(image);
            }
            else {
                let base64Id = this.map[image];
                if (!base64Id) {
                    base64Id = this.getBase64Id();
                    this.set(image, base64Id);
                }
                base64Ids.push(base64Id);
            }
        });
        return {
            urls,
            base64Ids
        };
    }
}
function getBase64Image() {
    let base64Image = window[base64ImageKeys.globalKey];
    if (base64Image)
        return base64Image;
    base64Image = new Base64Image();
    base64Image.registerHandler();
    return base64Image;
}
//# sourceMappingURL=data:application/json;base64,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